document.addEventListener("DOMContentLoaded", function() {
  if (window.matchMedia("(min-width: 801px)").matches) {
    const articleCarousel = document.querySelector('.article-carousel');
    if (articleCarousel) {
      const flickityOptions = {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        contain: true,
        watchCSS: true,
        groupCells: 4,
        arrowShape: { x0: 10, x1: 60, y1: 50, x2: 75, y2: 40, x3: 35 }
      };

      const flkty = new Flickity(articleCarousel, flickityOptions);

      const previousButton = document.querySelector('.button-row .button--previous');
      const nextButton = document.querySelector('.button-row .button--next');

      previousButton.addEventListener('click', function() {
        flkty.previous();
        if (flkty.selectedIndex === 0) {
          this.classList.add('inactive');
          nextButton.classList.remove('inactive');
        } else {
          this.classList.remove('inactive');
          nextButton.classList.add('first');
        }
      });

      nextButton.addEventListener('click', function() {
        console.log('index: ' + flkty.selectedIndex);
        console.log('slides: ' + flkty.slides.length);
        flkty.next();
        if (flkty.selectedIndex === 1) {
          this.classList.add('inactive');
          previousButton.classList.remove('inactive');
        } else {
          this.classList.remove('inactive');
          previousButton.classList.add('first');
        }
      });

      if (articleCarousel.querySelectorAll('.carousel-cell').length < 5) {
        document.querySelector('.button-row').remove();
      }
    }
  }

  if (document.querySelector('.ArticleTop__Audio')) {
    const track = document.getElementById('track');
    const controlBtn = document.getElementById('play-pause');
    const progressBar = document.querySelector('.audio-progress-filled');
    const progress = document.querySelector('.audio-progress');
    const currentTimeElement = document.querySelector('.time .current');
    const durationTimeElement = document.querySelector('.time .duration');

    function playPause() {
      if (track.paused) {
        track.play();
        setEqualizer();
        controlBtn.className = "pause";
      } else {
        track.pause();
        resetEqualizer();
        controlBtn.className = "play";
      }
    }

    track.onloadedmetadata = function() {
      let durationMinutes = Math.floor(track.duration / 60);
      let durationSeconds = Math.floor(track.duration - durationMinutes * 60);
      if (durationSeconds < 10) {
        durationSeconds = '0' + durationSeconds;
      }
      durationTimeElement.innerHTML = `${durationMinutes}:${durationSeconds}`;
    };

    controlBtn.addEventListener("click", playPause);
    track.addEventListener("ended", function() {
      controlBtn.className = "play";
    });

    // Current time and duration
    const currentTime = () => {
      let currentMinutes = Math.floor(track.currentTime / 60);
      let currentSeconds = Math.floor(track.currentTime - currentMinutes * 60);
      currentTimeElement.innerHTML = `${currentMinutes}:${currentSeconds < 10 ? '0' + currentSeconds : currentSeconds}`;
    };

    track.addEventListener('timeupdate', currentTime);

    // Progress bar
    track.addEventListener('timeupdate', () => {
      const percentage = (track.currentTime / track.duration) * 100;
      progressBar.style.width = `${percentage}%`;
    });

    // Change progress bar on click
    progress.addEventListener('click', (e) => {
      const progressTime = (e.offsetX / progress.offsetWidth) * track.duration;
      track.currentTime = progressTime;
    });
  }

  if (window.matchMedia("(max-width: 800px)").matches) {
    document.addEventListener('click', function(event) {
      if (event.target.matches('.articleSummary__Title')) {
        const articleSummary = document.querySelector('.articleSummary');
        articleSummary.classList.toggle('open');
        articleSummary.style.display = articleSummary.style.display === 'none' ? 'block' : 'none';
      }
    });
  }

  document.addEventListener('click', function(event) {
    if (event.target.matches('.articleSummary__item')) {
      const eq = Array.from(document.querySelectorAll('.articleSummary__item')).indexOf(event.target);
      const targetHeading = document.querySelectorAll('.articleBody__inner .rte h2')[eq];
      window.scrollTo({
        top: targetHeading.getBoundingClientRect().top + window.scrollY - 150,
        behavior: 'smooth'
      });
    }
  });

  let lines = document.querySelectorAll('.vertical');

  function setEqualizer() {
    lines.forEach(line => {
      line.style.animation = `equalizer ${Math.random() * (3 - 0.3) + 0.3}s ease infinite`;
      line.style.animationDirection = 'alternate-reverse';
    });
  }

  function resetEqualizer() {
    lines.forEach(line => {
      line.style.animation = 'none';
    });
  }
});

document.addEventListener("scroll", function() {
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  var scrollBottom = (document.documentElement.scrollHeight || document.body.scrollHeight) - document.documentElement.clientHeight;
  const scrollPercent = (scrollTop / scrollBottom) * 100 + "%";
  document.getElementById("progress-bar").style.setProperty("--scroll", scrollPercent);

  if (scrollTop === 0) {
    document.querySelector('.header').classList.remove('scrolling');
  } else {
    document.querySelector('.header').classList.add('scrolling');
  }
}, { passive: true });
